<template>
  <div>
    <loading v-if="!studentCards" class="cards__loading" full-screen="false" size="small" />
    <div v-else-if="!studentCards.length" class="centralized-horizontal cards__loading">
      <p class="centralized-horizontal-item">
        Não existem cartões para este aluno
      </p>
    </div>
    <div v-else>
      <table class="table table-striped table-spaced">
        <thead>
          <tr>
            <th>ID</th>
            <th>Bandeira</th>
            <th>Nome Titular</th>
            <th>Final</th>
            <th>Mês expiração</th>
            <th>Ano expiração</th>
            <th>Excluído</th>
            <th>Tipo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="card in studentCards" :key="card.id">
            <td>{{ card.id }}</td>
            <td>{{ card.card_brand }}</td>
            <td>{{ card.holder_name }}</td>
            <td>{{ card.last_digits }}</td>
            <td>{{ card.expiration_month }}</td>
            <td>{{ card.expiration_year }}</td>
            <td>{{ card.deleted | formatBoolean }}</td>
            <td>{{ card.card_type | formatCardType }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'components/Loading';

export default {
  data() {
    return {
      studentCity: 'Cidade',
      studentState: 'Estado',
    };
  },
  components: {
    Loading,
  },
  computed: mapState(['studentCards']),
};
</script>
